import { styled } from '@mui/material/styles';
import { Box, BottomNavigation, BottomNavigationAction, Typography } from '@mui/material';
import { styleTokens } from '../assets/styles/commonStyles';

export const StyledFooterBox = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  borderTop: '1px solid rgba(0, 0, 0, 0.08)',
  boxShadow: '0px -2px 8px rgba(0, 0, 0, 0.05)',
  backdropFilter: 'blur(10px)',
}));

export const StyledBottomNavigation = styled(BottomNavigation)(({ theme }) => ({
  justifyContent: 'center',
  backgroundColor: 'transparent',
  minHeight: 'auto',
  padding: '4px 8px',
  height: '20px',
  width: '100%',
  
  '& .MuiBottomNavigationAction-root': {
    minWidth: 'auto',
    padding: '4px 8px',
    minHeight: 'auto',
    flex: 1,
    
    '&:hover': {
      backgroundColor: styleTokens.colors.primaryAlpha[4],
    },
  },
  
  '& .MuiBottomNavigationAction-label': {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.text.secondary,
    marginTop: 0,
    
    '&.Mui-selected': {
      fontSize: '0.875rem',
    },
  },
}));

export const StyledBottomNavigationAction = styled(BottomNavigationAction)(({ theme }) => ({
  minHeight: 'auto',
  
  '& .MuiBottomNavigationAction-label': {
    marginTop: '0px !important',
    
    '&.Mui-selected': {
      fontSize: 'inherit',
    },
  },
}));

export const StyledIconBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  
  '& .MuiSvgIcon-root': {
    fontSize: '0.875rem',
    color: theme.palette.primary.main,
    marginRight: theme.spacing(0.5)
  },
  
  '& .MuiTypography-root': {
    fontWeight: 500,
    fontSize: '0.75rem'
  }
}));

export const FooterContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

export const FooterTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '0.75rem',
}));
